
import { LockDec, ValidateDec } from "@/decorators";
import { TSX, Component, Prop, Vue } from 'vue-facing-decorator'
import { getPaidLevelList, getPaidVipText } from '@/common/vip'

interface Props {
  data: any
}

@Component({})
export default class extends TSX<Props>()(Vue) implements Props {
  @Prop({})
  data: any;

  submitLoading = false;
  levelList: any[] = [];

  postData = {
    levelId: null as number | null,
    /** 0 按月、1 指定到期时间 */
    type: 0,
    month: 1,
    endDate: "" as any,
    remark: "",
  }

  async created() {
    await this.getLevelList();
    this.postData.levelId = this.activeLevelId || this.data?.payLevelId || this.levelList[0]?.id || null;
  }

  async getLevelList() {
    /** 走公共方法：用户列表也要这份等级名，同一次会话里只拉一次 */
    let { error, message, data } = await getPaidLevelList();
    if (error) return this.$error(message);
    this.levelList = data.list || [];
  }

  /** 未到期的付费等级 id：没等级、或已过期都算「可以随便选」 */
  get activeLevelId() {
    let expire = this.data?.paidExpireTime;
    if (!this.data?.payLevelId || !expire) return null;
    return new Date(expire).valueOf() > Date.now() ? this.data.payLevelId : null;
  }

  get currentVipText() {
    /** 等级名：详情页传进来的 data 带 paidLevelInfo，列表页的没有，用等级列表查 */
    let level = this.data?.paidLevelInfo;
    let name = (level && level.name) || this.levelNameMap[this.data?.payLevelId];
    let text = getPaidVipText(this.data, name);
    return text === "--" ? "无" : text;
  }

  get levelNameMap() {
    let map: Record<string, string> = {};
    this.levelList.forEach((item) => {
      map[item.id] = item.name;
    });
    return map;
  }

  validateMonth(v) {
    if (!v) throw '请输入赠送月数'
    if (Number(v) < 1) throw '赠送月数必须大于 0'
  }

  @ValidateDec("form")
  @LockDec("submitLoading")
  async submit() {
    let payload: any = {
      userId: this.data.id,
      levelId: this.postData.levelId,
      remark: this.postData.remark,
    };
    /** month 和 endDate 二选一，后端那边也是谁在就用谁 */
    if (this.postData.type == 0) {
      payload.month = Number(this.postData.month);
    } else {
      payload.endDate = this.postData.endDate;
    }
    await this.$postNotify("/manager/level/send-paid-vip", payload);
    this.$emit("resolve")
  }

  close() {
    this.$emit("reject", { msg: '取消' })
  }
}
